import React from "react";
import { ElementGroup } from '@whalecloud/page-builder-core/constant';
import Upload from "./components/Upload";
import UploadSettings from "./components/UploadSettings";
import { ReactComponent as PluginSvg } from "@assets/icons/upload_setting.svg";
import { getLocale, defaultTarget } from '@utils/util';

export default () => {
  const messages = getLocale();
  return {
    name: 'upload',
    group: ElementGroup.SELECT,
    target: defaultTarget,
    title: messages['PAGEBUIDER_ELEMENT_FORM_UPLOAD'],
    toolBarPreview: <PluginSvg />,
    data: {
      formItemSettings: {
        name: 'file',
        action: 'http://fish.iwhalecloud.com:8080/ueditor-example/uploadw',
        listType: 'text',
        buttonText: messages['PAGEBUIDER_SETTINGS_CLICK_TO_UPLOAD'],
        // eslint-disable-next-line no-template-curly-in-string
        download: 'http://fish.iwhalecloud.com:8080/ueditor-example/downLoadFile?docId=${id}',
        fileIdName: 'docId',
        showError:true,
      },
      formSettings: {
        label: messages['PAGEBUIDER_ELEMENT_FORM_UPLOAD']
      },
      settings: {
        width: {
          value: "100%"
        },
      }
    },
    pluginComponent: Upload, // 插件渲染组件
    pluginSettingComponent: UploadSettings, // 插件设置项组件
  }
}
